module.exports = __webpack_public_path__ + "img/nl.a51aed48.svg";